import { Routes, Route } from "react-router";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Sites from "./pages/Sites";
import Locations from "./pages/Locations";
import ClassEventList from "./pages/ClassEventList";
import ClassEventCheckinList from "./pages/ClassEventCheckinList";
import ClassEventJoinPhone from "./pages/ClassEventJoinPhone";
import NotFound from "./pages/NotFound";
import HandleSiteLocation from "./components/HandleSiteLocation";
import Hotjar from "@hotjar/browser";
import Store from "./pages/Store";
import Settings from "./pages/Settings";
import ErrorOnLoad from "./pages/ErrorOnLoad";

// if (import.meta.env.PROD || import.meta.env.DEV) {
// Hotjar
const siteId = 3789938;
const hotjarVersion = 6;
Hotjar.init(siteId, hotjarVersion);
// }

export default function App() {
  window.addEventListener(
    "message",
    (event) => {
      if (event.data === "reload") {
        window.location.reload();
      }
    },
    false
  );

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Sites />} />
        <Route path="/error" element={<ErrorOnLoad />} />
        <Route path="/:siteId" element={<Locations />} />

        <Route element={<HandleSiteLocation />}>
          <Route path="/:siteId/:locationId" element={<Home />} />
          <Route
            path="/:siteId/:locationId/class"
            element={<ClassEventList type={"classes"} />}
          />
          <Route
            path="/:siteId/:locationId/class/:classId/details"
            element={<ClassEventCheckinList type={"classes"} />}
          />
          <Route
            path="/:siteId/:locationId/class/:classId/details/join"
            element={<ClassEventJoinPhone type={"classes"} />}
          />
          <Route
            path="/:siteId/:locationId/event"
            element={<ClassEventList type={"events"} />}
          />
          <Route
            path="/:siteId/:locationId/event/:classId/details"
            element={<ClassEventCheckinList type={"events"} />}
          />
          <Route
            path="/:siteId/:locationId/event/:classId/details/join"
            element={<ClassEventJoinPhone type={"events"} />}
          />
          <Route path="/:siteId/:locationId/store" element={<Store />} />
          <Route
            path="/:siteId/:locationId/settings"
            element={<Settings />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
